// extracted by mini-css-extract-plugin
module.exports = {"container":"shop-by-shape-thumbnail_container__dblJI","text":"shop-by-shape-thumbnail_text__NzdXP"};